import { useEffect, useRef, useState } from 'react';
import { Compass, Gem, Heart } from 'lucide-react';

const values = [
  {
    icon: Gem,
    title: '匠造于心',
    subtitle: '',
    description: '毫厘之间，淬炼传世品质。',
    color: 'from-warm-gold to-dawn-orange'
  },
  {
    icon: Compass,
    title: '行稳致远',
    subtitle: '',
    description: '传承非遗，领航行业征程。',
    color: 'from-deep-lake to-deep-lake-light'
  },
  {
    icon: Heart,
    title: '情系钓友',
    subtitle: '',
    description: '以漂为媒，共赴垂钓之乐。',
    color: 'from-dawn-orange to-warm-gold'
  }
];

export default function BrandValues() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-20 md:py-32 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span
            className={`inline-block text-sm font-medium text-dawn-orange tracking-wider uppercase mb-4 transition-all duration-700 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
            }`}
          >
            Brand Values
          </span>
          <h2
            className={`text-3xl md:text-4xl lg:text-5xl font-serif-zh font-bold text-deep-lake mb-4 transition-all duration-700 delay-100 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
            }`}
          >
            品牌主张
          </h2>
          <p
            className={`text-lg text-gray-600 max-w-2xl mx-auto transition-all duration-700 delay-200 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
            }`}
          >
            只为给您最好的垂钓体验
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {values.map((value, index) => (
            <div
              key={value.title}
              className={`group relative transition-all duration-700 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: `${300 + index * 100}ms` }}
            >
              <div className="relative p-8 bg-gray-50 rounded-2xl hover:bg-white hover:shadow-xl transition-all duration-500 border border-gray-100">
                <div
                  className={`absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 w-16 h-16 rounded-2xl bg-gradient-to-br ${value.color} flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-500`}
                >
                  <value.icon className="w-8 h-8 text-white" />
                </div>

                <div className="pt-8 text-center">
                  <h3 className="text-2xl font-serif-zh font-bold text-deep-lake mb-1">
                    {value.title}
                  </h3>
                  {value.subtitle && (
                    <p className="text-sm text-gray-400 mb-4 tracking-wider">
                      {value.subtitle}
                    </p>
                  )}
                  <p className="text-gray-600 leading-relaxed">
                    {value.description}
                  </p>
                </div>

                <div
                  className={`absolute bottom-0 left-1/2 -translate-x-1/2 w-0 h-1 bg-gradient-to-r ${value.color} rounded-full group-hover:w-1/2 transition-all duration-500`}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
